export default {
  source: {
    url: "mapbox://mepa1363.4vky4bll"
  },
  layer: {
    id: "safety-ems-stations",
    source: "pickyourplace_ems",
    minZoom: 5,
    maxZoom: 22,
    color: "#F44336",
    icon: "hospital-15",
    text: "name"
  }
};
